import Layout from "../../components/shared/layout/layout";
import Seo from "../../components/shared/seo/seo";

export default function Widerrufsrechts(){
    return (
        <Layout>
            <Seo title="Widerrufsrecht" description="Widerrufsrecht des Weinguts Gisperg." path="/widerrufsrecht" />
            <section className="no_fill small background_light">
                <h1>Widerrufsrecht</h1>
                <div className="col-8 left">
                    <p>
                    Widerrufsrecht
                    </p>
                    <p>
                    Informationen zur Ausübung des Widerrufsrechts im Falle eines Kaufvertrags über die Lieferung einer oder mehrerer Waren in einer Sendung.
                    </p>
                    <p>
                    Unternehmern steht kein Rücktrittsrecht/Widerrufsrecht zu.
                    </p>
                    <p>
                    Für Verbraucher im Sinne des Konsumentenschutzgesetzes, die eine Bestellung im Wege des Fernabsatzes getätigt haben, gilt:
                    </p>
                    <p>
                    Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.
                    </p>
                    <p>
                    Um dieses Widerrufsrecht auszuüben, muss der Käufer uns, der Gisperg Johann & Mitbesitzer GesnbR, Hauptstraße 14, 2524 Teesdorf, Tel.: +43 (0) 2253 / 81464 , E-Mail: wein@weingut-gisperg.at, mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, Telefax oder E-Mail) über seinen Entschluss, den Vertrag zu widerrufen, informieren.
                    </p>
                    <p>
                    Folgen des Widerrufs
                    </p>
                    <p>
                    Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet. Nicht gewünschte Ware kann, so sie noch nicht angebrochen bzw. beschädigt ist, auf Kosten des Käufers zurückgesendet werden. Die Rücksendung muss im Originalkarton oder einem gleichwertigen Versandkarton für Glasflaschen erfolgen.
                    </p>
                    <p>
                    Zur Wahrung der Widerrufsfrist reicht es aus, dass der Käufer die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absendet. Rücksendekosten sind nach der Umsetzung der Verbraucherrechterichtlinie grundsätzlich vom Verbraucher zu tragen.
                    </p>
                    <p>
                    Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.
                    </p>
                    <p>
                    Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.
                    </p>
                    <p>
                    Kein Rücktrittsrecht besteht auch bei (§ 18 FAGG) Waren, die nach Kundenspezifikation angefertigt wurden oder auf die persönlichen Bedürfnisse des Kunden zugeschnitten sind;
                    </p>
                    <p>
                    Muster-Widerruf
                    </p>
                    <p>
                    –	An
                    </p>
                    <p>
                    [hier ist der Name, die Anschrift und gegebenenfalls die Faxnummer und E-Mail-Adresse des Unternehmers durch den Unternehmer einzufügen]
                    </p>
                    <p>
                    Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)
                    </p>
                    <p>
                    –	Bestellt am (*)/erhalten am (*)
                    </p>
                    <p>
                    –	Name des/der Verbraucher(s)
                    </p>
                    <p>
                    –	Anschrift des/der Verbraucher(s)
                    </p>
                    <p>
                    –	Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)
                    </p>
                    <p>
                    –	Datum
                    </p>
                    <p>
                    (*) Unzutreffendes streichen.
                    </p>
                </div>
            </section>
        </Layout>
    );
}